import React from "react";

import {SvgIcon, SvgIconProps} from "@mui/material";

export default function TapbackEmphasisIcon(props: SvgIconProps) {
	return (
		<SvgIcon {...props}>
			<path d="M13,5.5L13,14.5C13,15.0523 12.5523,15.5 12,15.5L12,15.5C11.4477,15.5 11,15.0523 11,14.5L11,5.5C11,4.9477 11.4477,4.5 12,4.5L12,4.5C12.5523,4.5 13,4.9477 13,5.5ZM13,18.5L13,18.5C13,19.0523 12.5523,19.5 12,19.5L12,19.5C11.4477,19.5 11,19.0523 11,18.5L11,18.5C11,17.9477 11.4477,17.5 12,17.5L12,17.5C12.5523,17.5 13,17.9477 13,18.5Z" />
		</SvgIcon>
	);
}